var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-1518.545 -22.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(1518.545 22.545)",
    fill: "none",
    stroke: "#8a929f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M2.741-7.144H4.393V-7.5c0-.7.262-1.071,1.192-1.61a2.684,2.684,0,0,0,1.5-2.412v-.007c0-1.568-1.305-2.681-3.242-2.681C1.74-14.209.612-12.989.534-11.4l-.007.078H2.194l.007-.064a1.446,1.446,0,0,1,1.554-1.376,1.34,1.34,0,0,1,1.49,1.3v.007c0,.7-.3,1.078-1.178,1.61A2.221,2.221,0,0,0,2.741-7.64ZM3.592-3.81a1.006,1.006,0,0,0,1.029-1,1,1,0,0,0-1.029-1,1.007,1.007,0,0,0-1.036,1A1.012,1.012,0,0,0,3.592-3.81Z",
    transform: "translate(1524.427 41.656)",
    fill: "#8a929f",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpWhite);
export default __webpack_public_path__ + "static/media/help-white.dbd6b33f883b8c2abbc667d74d42b57a.svg";
export { ForwardRef as ReactComponent };